/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createCreateUserResponseFromDiscriminatorValue, createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, serializeCreateUserRequest, serializeCreateUserResponse, type CreateUserRequest, type CreateUserResponse, type ErrorResponse, type InternalErrorResponse } from '../../models/index.js';
// @ts-ignore
import { CustomerAssociationRequestBuilderRequestsMetadata, type CustomerAssociationRequestBuilder } from './customerAssociation/index.js';
// @ts-ignore
import { CustomerAssociationsRequestBuilderRequestsMetadata, type CustomerAssociationsRequestBuilder } from './customerAssociations/index.js';
// @ts-ignore
import { ExistsRequestBuilderRequestsMetadata, type ExistsRequestBuilder } from './exists/index.js';
// @ts-ignore
import { OrganizationsRequestBuilderRequestsMetadata, type OrganizationsRequestBuilder } from './organizations/index.js';
// @ts-ignore
import { ProfileRequestBuilderRequestsMetadata, type ProfileRequestBuilder } from './profile/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/users
 */
export interface UsersRequestBuilder extends BaseRequestBuilder<UsersRequestBuilder> {
    /**
     * The customerAssociation property
     */
    get customerAssociation(): CustomerAssociationRequestBuilder;
    /**
     * The customerAssociations property
     */
    get customerAssociations(): CustomerAssociationsRequestBuilder;
    /**
     * The exists property
     */
    get exists(): ExistsRequestBuilder;
    /**
     * The organizations property
     */
    get organizations(): OrganizationsRequestBuilder;
    /**
     * The profile property
     */
    get profile(): ProfileRequestBuilder;
    /**
     * Create a User
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<CreateUserResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: CreateUserRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<CreateUserResponse | undefined>;
    /**
     * Create a User
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: CreateUserRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const UsersRequestBuilderUriTemplate = "{+baseurl}/api/users";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const UsersRequestBuilderNavigationMetadata: Record<Exclude<keyof UsersRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    customerAssociation: {
        requestsMetadata: CustomerAssociationRequestBuilderRequestsMetadata,
    },
    customerAssociations: {
        requestsMetadata: CustomerAssociationsRequestBuilderRequestsMetadata,
    },
    exists: {
        requestsMetadata: ExistsRequestBuilderRequestsMetadata,
    },
    organizations: {
        requestsMetadata: OrganizationsRequestBuilderRequestsMetadata,
    },
    profile: {
        requestsMetadata: ProfileRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const UsersRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: UsersRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createCreateUserResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeCreateUserRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
